<!-- src/components/VoiceItem.vue -->
<template>
  <div
    class="yyyp"
    @click="changeClick"
    :class="changeClickType && voiceClickId == voice.id ? 'activeClass' : ''"
  >
    <div class="voice-info" @click.stop="handleClick">
      <img :src="playIcon" alt="播放控制" class="sybf" />
      <div
        class="syTitle"
        :class="
          changeClickType && voiceClickId == voice.id ? 'activeSyTitle' : ''
        "
      >
        <span v-if="voice.copyStatus == '2'">
          {{ voice.name || "未命名声音" }}</span
        >
        <span v-else>{{voice.name}}（此音频正在生成中，请稍等...）</span>
      </div>
    </div>
    <div>
      <img
        src="@/assets/aiVideo/edit.svg"
        alt="编辑"
        class="deleteImg edit"
        @click.stop="onEdit"
        v-if="editType && voice.soundType == 2&&voice.copyStatus == '2'"
      />
      <img
        src="@/assets/aiVideo/delete.svg"
        alt="删除"
        class="deleteImg"
        @click.stop="onDelete"
        v-if="
          (!editType || (voice.soundType && voice.soundType == '2')) &&
          deleteType&&voice.copyStatus == '2'
        "
      />
      <!-- <img
        @click.stop="changeClick"
        src="@/assets/aiVideo/xz.svg"
        alt="#"
        class="changeTypeImg"
        v-if="changeClickType&&voiceClickId==voice.id"
      /> -->
      <!-- <img
        @click.stop="changeClick"
        src="@/assets/aiVideo/wxz.svg"
        alt="#"
        class="changeTypeImg"
        v-if="changeClickType&&voiceClickId!=voice.id"
      /> -->
    </div>

    <audio
      ref="audio"
      :src="voice.url"
      @play="onPlay"
      @pause="onPause"
      @ended="onEnded"
    ></audio>
  </div>
</template>

<script>
export default {
  name: "VoiceItem",
  props: {
    voice: {
      type: Object,
      required: true,
    },
    editType: {
      type: Boolean,
      default: false,
    },
    deleteType: {
      type: Boolean,
      default: true,
    },
    changeClickType: {
      type: Boolean,
      default: false,
    },
    voiceClickId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isPlaying: false,
    };
  },
  // require("@/assets/aiVideo/xzbf.png")
  computed: {
    playIcon() {
      if (this.changeClickType && this.voiceClickId == this.voice.id) {
        return this.isPlaying
          ? require("@/assets/aiVideo/xzbf.png") // 暂停图标
          : require("@/assets/aiVideo/xzzt.png"); // 播放图标
      }
      return this.isPlaying
        ? require("@/assets/aiVideo/syzt.png") // 暂停图标
        : require("@/assets/aiVideo/sybf.svg"); // 播放图标
    },
  },
  methods: {
    // ✅ 提供给父组件调用：暂停当前音频
    pause() {
      const audio = this.$refs.audio;
      if (audio && !audio.paused) {
        audio.pause();
      }
    },

    async handleClick() {
      if (this.voice.copyStatus == "0") return;
      this.$emit("request-play", this);
      const audio = this.$refs.audio;
      if (!audio) return;

      if (this.isPlaying) {
        audio.pause();
      } else {
        try {
          await audio.play();
        } catch (err) {
          console.error("播放失败:", err);
          this.$emit("play-error", err);
        }
      }
    },

    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onEnded() {
      this.isPlaying = false;
    },
    onDelete(event) {
      this.$emit("delete", this.voice, event);
    },
    onEdit(event) {
      this.$emit("edit", this.voice, event);
    },
    changeClick(event) {
      if (this.voice.copyStatus == "0") return;
      this.$emit("change", this.voice, event);
    },
  },
  beforeDestroy() {
    this.pause();
  },
};
</script>

<style scoped>
.yyyp {
  background-color: #d2dae4;
  box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 13.333vw;
  margin-left: 2.666vw;
  margin-right: 2.666vw;
  border-radius: 1.6vw;
  padding: 0 4.8vw 0 4.2666vw;
}

.voice-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.deleteImg {
  width: 4.2666vw;
  height: 4.2666vw;
  cursor: pointer;
}

.sybf {
  width: 5.333vw;
  height: 5.333vw;
  margin-right: 3.2vw;
}

.syTitle {
  line-height: 4.8vw;
  font-size: 3.2vw;
  color: #1f2226;
  text-align: center;
  font-weight: 400;
}
.activeSyTitle {
  color: #ffffff;
}
.edit {
  margin-right: 4.2666vw;
}
.changeTypeImg {
  width: 4.2666vw;
  height: 4.2666vw;
}
.activeClass {
  color: red !important;
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  );
}
</style>
